import { render, staticRenderFns } from "./64.vue?vue&type=template&id=6119421f&scoped=true&"
var script = {}
import style0 from "./64.vue?vue&type=style&index=0&id=6119421f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6119421f",
  null
  
)

export default component.exports